import React, { useState, useEffect, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  ConfirmationModal,
  Loading,
  FormatValueToDecimal,

  DateSelect,
  DetectMimeTypeFromBase64, HandleFileUpload, DownloadFile,
  InvoiceStatusSelectWithAll,
  CustomerSelect,
  ChartOfAccountsSelect,
  DeliveryOrderSelect,
  ItemReturnSelect,
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import NoAccess from "../NoAccess";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// MUI Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import NotInterestedIcon from '@mui/icons-material/NotInterested';

export const DeliveryReturn = ({active}) => {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.returnNumber?.toLowerCase().includes(lowerValue) 
        || item.customerName1?.toLowerCase().includes(lowerValue) 
    );

    setData(filtered);
  };
//#endregion







//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const [customerFilter, setCustomerFilter] = useState(null);
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion








//#region Variables
  const [selectedData, setSelectedData] = useState(null);

  const [deliveryReturnDetails, setDeliveryReturnDetails] = useState([]);
  const [returnNumber, setReturnNumber] = useState("xxxxxx");
  const [reference, setReference] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const [returnDate, setReturnDate] = useState(today);
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");

  const resetVariables = () => {
    setDeliveryReturnDetails([]);
    setReturnNumber("xxxxxx");
    setReference(null);
    setReturnDate(today);
    setStatus("");
    setNotes("");
    setUploadedFile("");
    
    setSelectedData(null);
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/DeliveryReturn/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);
//#endregion







// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const addHandleClick = async () => {
    openAddForm()
  }
  
  const handleAddData = async () => {
    const _deliveryReturnDetails = deliveryReturnDetails.map((detail) => {
      return ({
        itemCode: detail.itemCode,
        totalQuantity: detail.totalQuantity,
        cost: detail.cost,
        totalAmount: detail.totalAmount,
        refundQuantity: detail.refundQuantity,
        replacementQuantity: detail.replacementQuantity,
        deliveryReturnDetailAccounts: [
          {
            amount: detail.totalAmount ?? 0,
            drAccountId: detail.drAccount?.id ?? 0,
            crAccountId: detail.crAccount?.id ?? 0,
            isMainItem: true,
          },

          // BOM vs SINGLE ITEM
          ...(detail?.itemComponents?.length > 0
            ? detail.itemComponents.map((component) => {
              const _quantity = (component.conversionRate ?? 1) * (detail.totalQuantity ?? 0)
              const _averageCost = (component.averageCost ?? 0)
              const _amount = _quantity * _averageCost

              return ({
                amount: _amount,
                drAccountId: component.drAccount?.id ?? 0,
                crAccountId: component.crAccount?.id ?? 0,
                isMainItem: false,
              })})
            : (
                detail?.categoryName !== "Other Sale" &&
                detail?.categoryName !== "Other Sales Income" &&
                detail?.categoryName !== "Other Service Income"
              )
              ? [
                  {
                    amount: (detail?.averageCost ?? 0) * detail.totalQuantity,
                    drAccountId: detail?.inventoryAccountId ?? 0,
                    crAccountId: detail?.costOfGoodsAccountId ?? 0,
                    isMainItem: false,
                  },
                ]
              : [])
        ]
      })
    })

    const data = {
      deliveryReturnDetails: _deliveryReturnDetails,
      doNumber: reference?.doNumber ?? "",
      returnNumber: returnNumber, //temporary
      returnDate: returnDate,
      status: "Posted",
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/DeliveryReturn`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion






// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setDeliveryReturnDetails(_data?.deliveryReturnDetails ?? []);
    setReturnNumber(_data?.returnNumber ?? "");
    setReference(_data?.reference ?? null);
    setReturnDate(_data?.returnDate ?? null);
    setStatus(_data?.status ?? "");
    setNotes(_data?.notes ?? "");
    setUploadedFile(_data?.uploadedFile
                ? {
                    base64: _data?.uploadedFile,
                    contentType: DetectMimeTypeFromBase64(
                      _data?.uploadedFile
                    ),
                    fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                      _data?.uploadedFile
                    ).split("/")[1]}`
                  }
                : null)

    setLoading(false);
    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const data = {
      deliveryReturnDetails: deliveryReturnDetails,
      doNumber: reference?.doNumber ?? "",
      returnNumber: returnNumber, //temporary
      returnDate: returnDate,
      status: status,
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      updatedDate: new Date(),
      updatedBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/DeliveryReturn/update/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion







// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setDeliveryReturnDetails(_data?.deliveryReturnDetails ?? []);
    setReturnNumber(_data?.returnNumber ?? "");
    setReference(_data?.reference ?? null);
    setReturnDate(_data?.returnDate ?? null);
    setStatus(_data?.status ?? "");
    setNotes(_data?.notes ?? "");
    setUploadedFile(_data?.uploadedFile
                ? {
                    base64: _data?.uploadedFile,
                    contentType: DetectMimeTypeFromBase64(
                      _data?.uploadedFile
                    ),
                    fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                      _data?.uploadedFile
                    ).split("/")[1]}`
                  }
                : null)

    setLoading(false);
    openViewForm();
  }
//#endregion


















// #region Void Invoice
  const [showVoidForm, setShowVoidForm] = useState(false);

  const openVoidForm = () => {
    setShowVoidForm(true);
  }
  const closeVoidForm = () => {
    setShowVoidForm(false);
    setSelectedData(null);
  }

  const voidHandleClick = async (data) => {
    setSelectedData(data);
    openVoidForm();
  }

  const handleVoidStatus = async () => {
    try {
      setLoading(true);

      const _data = {
        id: selectedData?.id,
        status: "Void"
      }

      await axios.post(`${apiUrl}/api/DeliveryReturn/change-status`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to change data: ${errorMessage}`);
    } finally {
      setLoading(false)
    }
  }
// #endregion







//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'RETURN NUMBER', 
    // 'DO DATE', 
    'DO NUMBER', 
    'CUSTOMER', 
    // 'DUE DATE', 
    // 'ITEM/S', 
    // 'BILL AMOUNT', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'returnNumber', 
    // 'doDate', 
    'doNumber', 
    'customer', 
    // 'dueDate', 
    // 'deliveryOrderDetailLines', 
    // 'billDetailsAmount', 
    'status', 
    'actions'
  ]

  const actions = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: false,
    },
    { 
      name: "Void", 
      tooltip: "Void",
      icon: <NotInterestedIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: voidHandleClick,
      visible: true,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/DeliveryReturn/customer/${customerFilter?.customerId ?? "All"}/status/${statusFilter ? statusFilter : "All"}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [customerFilter, statusFilter]);

  useEffect(() => {
    if(active){
      fetchData();
    }
  }, [active, fetchData])
//#endregion










//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasPayables) {
    return <NoAccess />;
  }
//#endregion


  return (
    <>
      <div className="py-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          {/* Search and Filters */}
          <div className="flex justify-between items-center gap-2 w-full">
            <div className="w-full">
              <input
                type="text"
                placeholder="Search account..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
          </div>
          <div className="flex gap-3 w-full justify-start md:justify-end">
            <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
            <button onClick={addHandleClick} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Return
            </button>
          </div>
        </div>

        <CreateTable
          tableName={"Delivery Return"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Return"}

        data={data}
        deliveryReturnDetails={deliveryReturnDetails} setDeliveryReturnDetails={setDeliveryReturnDetails}
        returnNumber={returnNumber} setReturnNumber={setReturnNumber}
        reference={reference} setReference={setReference}
        returnDate={returnDate} setReturnDate={setReturnDate}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        status={status} setStatus={setStatus}
        notes={notes} setNotes={setNotes}
        isEditable={true}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Return"}

        data={data}
        deliveryReturnDetails={deliveryReturnDetails} setDeliveryReturnDetails={setDeliveryReturnDetails}
        returnNumber={returnNumber} setReturnNumber={setReturnNumber}
        reference={reference} setReference={setReference}
        returnDate={returnDate} setReturnDate={setReturnDate}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        status={status} setStatus={setStatus}
        notes={notes} setNotes={setNotes}
        isEditable={true}
      />

      <ViewModal
        visible={showViewForm}
        onClose={closeViewForm}
        modalName="Delivery Return Preview"
        data={selectedData}
      />
            
      <ConfirmationModal 
        visible={showVoidForm} 
        onClose={closeVoidForm} 
        onSave={handleVoidStatus} 
        modalName={"Void"} 
        message={`Do you want to void this [ ${selectedData?.returnNumber || ""} ]?.`}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        customerFilter={customerFilter} setCustomerFilter={setCustomerFilter}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
}









//#region AddUpdate/View Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  
  deliveryReturnDetails, setDeliveryReturnDetails,
  returnNumber, setReturnNumber,
  reference, setReference,
  returnDate, setReturnDate,
  uploadedFile, setUploadedFile,
  status, setStatus,
  notes, setNotes,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [showDetails, setShowDetails] = useState(true);

  const [showReferenceSelectForm, setShowReferenceSelectForm] = useState(false);
  const openReferenceSelectForm = () => {
    setShowReferenceSelectForm(true);
  }
  const closeReferenceSelectForm = () => {
    setShowReferenceSelectForm(false);
  }

  const [selectedItem, setSelectedItem] = useState(null);
  const [showItemSelectForm, setShowItemSelectForm] = useState(false);
  const openItemSelectForm = () => {
    setShowItemSelectForm(true);
  }
  const closeItemSelectForm = () => {
    setShowItemSelectForm(false);
  }

  useEffect(() => {
    if (visible && selectedItem) {
      const exists = deliveryReturnDetails.some(
        (item) => item.itemCode === selectedItem.itemCode
      );

      if (exists) {
        setFailMessage(
          `${selectedItem.itemDescription} is already added`
        );
        setSelectedItem(null);
        return;
      }

      const newItem = {
        ...selectedItem,
        itemCode: selectedItem?.itemCode ?? "",
        itemDescription: selectedItem?.itemDescription ?? "",
        brandName: selectedItem?.brandName ?? "",
        categoryName: selectedItem?.categoryName ?? "",
        uomName: selectedItem?.uomName ?? "",
        totalQuantity: 0,
        cost: selectedItem?.unitPrice ?? 0,
        averageCost: selectedItem?.averageCost ?? 0,
        receivedQty: selectedItem?.receivedQty ?? 0,
        totalAmount: 0,
        refundQuantity: 0,
        replacementQuantity: 0,
        itemComponents: selectedItem?.itemComponents?.map((comp) => {
          return ({
            ...comp,
            detail: {
              ...selectedItem,
              itemCode: selectedItem?.itemCode ?? "",
              itemDescription: selectedItem?.itemDescription ?? "",
              brandName: selectedItem?.brandName ?? "",
              categoryName: selectedItem?.categoryName ?? "",
              uomName: selectedItem?.uomName ?? "",
              totalQuantity: 0,
              cost: selectedItem?.unitPrice ?? 0,
              averageCost: selectedItem?.averageCost ?? 0,
              receivedQty: selectedItem?.receivedQty ?? 0,
              totalAmount: 0,
              refundQuantity: 0,
              replacementQuantity: 0,
            }
          })
        })
      };

      setDeliveryReturnDetails((prev) => [...prev, newItem]);
      setSelectedItem(null);
    }
  }, [visible, selectedItem, deliveryReturnDetails, setDeliveryReturnDetails]);

  const handleQuantityChange = (itemCode, value) => {
    const totalQuantity = Number(value) || 0;

    setDeliveryReturnDetails((prev) =>
      prev.map((item) =>
        item.itemCode === itemCode
          ? {
              ...item,
              totalQuantity,
              totalAmount: totalQuantity * (Number(item.cost) || 0),
              refundQuantity: totalQuantity * (Number(item.cost) || 0),
              itemComponents: item?.itemComponents?.map((comp) => {
                return (
                  {
                    ...comp,
                    detail: {
                      ...item,
                      totalQuantity,
                      totalAmount: totalQuantity * (Number(item.cost) || 0),
                      refundQuantity: totalQuantity * (Number(item.cost) || 0),
                    }
                  }
                )
              })
            }
          : item
      )
    );
  };

  useEffect(() => {
    if(visible && deliveryReturnDetails.length > 0){
      const _amount = deliveryReturnDetails?.reduce((acc, item) => acc + (Number(item?.totalAmount) || 0), 0) || 0;

      setAmount(_amount)
    }
  }, [visible, deliveryReturnDetails])

  





//#region Details
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [isComponent, setIsComponent] = useState(false);
  const [showUpdateDetailForm, setShowUpdateDetailForm] = useState(false);
  const openUpdateDetailForm = () => {
    setShowUpdateDetailForm(true);
  }
  const closeUpdateDetailForm = () => {
    setShowUpdateDetailForm(false);
    setIsComponent(false);
    setSelectedDetail(null)
  }

  const editHandleDetailClick = (_data) => {
    setSelectedDetail(_data)
    openUpdateDetailForm();
  }

  const [showDeleteDetailForm, setShowDeleteDetailForm] = useState(false);
  const openDeleteDetailForm = () => {
    setShowDeleteDetailForm(true);
  }
  const closeDeleteDetailForm = () => {
    setShowDeleteDetailForm(false);
    setSelectedDetail(null)
  }

  const deleteHandleDetailClick = (_data) => {
    setSelectedDetail(_data)
    openDeleteDetailForm();
  }

  const editComponentHandleDetailClick = (_data) => {
    setSelectedDetail(_data)
    openUpdateDetailForm()
    setIsComponent(true)
  }

  const handleDeleteDetail = () => {
    if (!selectedDetail) return;

    // 1. Identify the Sales Order ID of the item being deleted
    const targetSalesOrderId = selectedDetail.salesOrderId;

    // 2. Calculate the new lines first so we can check the remaining count
    const updatedLines = deliveryReturnDetails.filter(
      (item) => item.itemCode !== selectedDetail.itemCode
    );

    // 3. Check if there are any items left belonging to that Sales Order
    const hasRemainingItems = updatedLines.some(
      (item) => item.salesOrderId === targetSalesOrderId
    );

    // 4. Update the detailed lines (the list currently shown in the UI)
    setDeliveryReturnDetails(updatedLines);

    // 5. If no items are left for this SO, remove the SO from the source state
    if (!hasRemainingItems) {
      setDeliveryReturnDetails((prev) => 
        prev.filter((so) => so.salesOrderId !== targetSalesOrderId)
      );
    }
  };
  const actionsDetail = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleDetailClick,
      visible: true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleDetailClick,
      visible: true,
    },
  ];

  const actionsDetailComponent = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editComponentHandleDetailClick,
      visible: true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleDetailClick,
      visible: true,
    },
  ];
//#endregion


  const resetLocalVariables = () => {
    setFailMessage("")
    setAmount(0);
    setLoading(false);
    setSelectedItem(null);
  }





  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (deliveryReturnDetails.length <= 0 && !reference && !returnDate) {
      setFailMessage("Please fill up all required fields.");
      return;
    }

    await onSave();
    closeModal();
  };

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };






  const handleFileChange = async (e) => {
    const fileData = await HandleFileUpload(e);

    if (fileData) {
      setUploadedFile(fileData);
    }
  };

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Related Parties */}
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Related Parties</h3>
                  </div>

                  {isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Reference <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Reference"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${reference ? `${reference?.doNumber ?? ""}` : ""}`}
                          readOnly
                        />
                        {!reference ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openReferenceSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setReference(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                  :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Reference <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Reference"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${reference ? `${reference?.doNumber ?? ""}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }
                </>

                {/* Details */}
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Return Date  <span className="text-red-500">*</span>
                  </label>
                  <DateSelect data={returnDate} setData={setReturnDate} isEditable={isEditable}/>
                </div>

                <div className="md:col-span-2 mt-4">
                  {/* Toggle Header Button */}
                  <button
                    type="button"
                    onClick={() => setShowDetails(!showDetails)}
                    className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showDetails ? 'text-theme-color' : 'text-gray-400'}`}>
                        Items to Return
                      </h3>
                      {/* Badge showing count */}
                      {deliveryReturnDetails?.length > 0 && (
                        <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                          {deliveryReturnDetails.length}
                        </span>
                      )}
                    </div>
                    
                    <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showDetails ? "rotate-180" : ""}`}>
                      <ExpandMoreIcon /> 
                    </div>
                  </button>

                  {/* Expandable Content Area */}
                  <AnimatePresence>
                    {showDetails && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="overflow-hidden"
                      >
                        <div className="py-5 space-y-5">
                          {/* Add button */}
                          <div className="flex gap-3 w-full justify-start">
                            {isEditable &&
                              <>
                                {reference ? (
                                  <button
                                    type="button"
                                    onClick={openItemSelectForm}
                                    className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                  >
                                    <AddCircleOutlineIcon fontSize="small" />
                                    Select Item
                                  </button>
                                ) : (
                                  <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                    </svg>
                                    Please choose a reference first to add item
                                  </div>
                                )}
                              </>
                            }
                          </div>

                          {/* List of Bills Account */}
                          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                            <div className="space-y-6">

                              {/* Items List */}
                              <div className="divide-y divide-gray-100">
                                {deliveryReturnDetails.map((item, index) => {
                                  const qty = item.totalQuantity ?? 0;
                                  const unitPrice = item?.averageCost ?? 0;
                                  const totalAmount = unitPrice * qty;

                                  return (
                                    <div key={index} className="p-6 hover:bg-gray-50 transition-colors">
                                      <div className="grid grid-cols-1 md:grid-cols-7 lg:grid-cols-9 gap-2">
                                        
                                        {/* Item Info */}
                                        <div className="md:col-span-2">
                                          <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Item</p>
                                          <p className="text-sm font-bold text-gray-900">{`${item.itemDescription ?? ""}` }</p>
                                          <p className="text-xs font-bold text-gray-400">{`${item.brandName ?? ""}` }</p>
                                        </div>

                                        {/* Dr */}
                                        <div>
                                          <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Cost (Dr)</p>
                                          <p className="text-xs font-bold text-gray-900">{`${item.drAccount?.accountName ?? ""}` }</p>
                                        </div>

                                        {/* Cr */}
                                        <div>
                                          <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Inventory (Cr)</p>
                                          <p className="text-xs font-bold text-gray-900">{`${item.crAccount?.accountName ?? ""}` }</p>
                                        </div>

                                        <div>
                                          <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Received Qty</p>
                                          <div className="flex items-center gap-2">
                                            <div className="text-sm">
                                                <span className="text-gray-900 font-semibold"> {`${item?.receivedQty?.toLocaleString()}  ${item.uomName ?? ""}`}</span>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Returned Qty */}
                                        <div>
                                          <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">
                                            Returned Qty
                                          </p>

                                          <div className="flex items-center gap-2">
                                            <input
                                              type="number"
                                              min="0"
                                              max={item.receivedQty ?? 0}
                                              step="any"
                                              value={item.totalQuantity ?? 0}
                                              onChange={(e) => handleQuantityChange(item.itemCode, e.target.value)}
                                              className={`w-20 rounded-md border px-2 py-1 text-sm focus:outline-none ${
                                                Number(item.totalQuantity ?? 0) > Number(item.receivedQty ?? 0)
                                                  ? "border-red-500 focus:border-red-500"
                                                  : "border-gray-300 focus:border-blue-500"
                                              }`}
                                            />

                                            <span className="text-xs text-gray-400">
                                              {item.uomName ?? ""}
                                            </span>
                                          </div>

                                          {Number(item.totalQuantity ?? 0) > Number(item.receivedQty ?? 0) && (
                                            <p className="mt-1 text-xs text-red-600">
                                              Returned quantity cannot exceed the received quantity.
                                            </p>
                                          )}
                                        </div>

                                        {/* Pricing */}
                                        <div>
                                          <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Unit Price</p>
                                          <p className="text-sm text-gray-900">₱{item.cost?.toLocaleString()}</p>
                                        </div>

                                        {/* Totals */}
                                        <div>
                                          <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Total Amount</p>
                                          <p className="text-sm font-bold text-green-600">₱{item.totalAmount?.toLocaleString()}</p>
                                        </div>

                                        {/* Actions */}
                                        {isEditable && (
                                          <div className="flex justify-end items-center gap-2">
                                            {actionsDetail?.map((action, actionIdx) => (
                                                <button
                                                  key={actionIdx}
                                                  onClick={() => action.function(item)}
                                                  className="p-2 text-gray-400 hover:text-red-600 rounded-lg hover:bg-red-50 transition-all"
                                                >
                                                  {action.icon || action.label}
                                                </button>
                                            ))}
                                          </div>
                                        )}
                                      </div>

                                      { item?.itemComponents?.length > 0 ?
                                        <div key={index} className="flex flex-col gap-4 mt-2">
                                          <div className="flex items-center gap-2 py-3">
                                            <span className="text-[10px] font-bold uppercase tracking-widest text-indigo-500 bg-indigo-50 px-2 py-0.5 rounded">
                                              Item Components
                                            </span>
                                            <div className="h-px flex-1 bg-gray-100"></div>
                                          </div>
                                          { item?.itemComponents?.map((component, index) => {

                                            const componentQty = (component.conversionRate ?? 0) * (item.totalQuantity ?? 0)
                                            const componentTotalAmount = componentQty * (component.averageCost ?? 0)

                                            return (
                                              <div key={index} className="grid grid-cols-1 md:grid-cols-7 lg:grid-cols-9 gap-2">
                                                <div className="md:col-span-2">
                                                  {/* <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Item</p> */}
                                                  <p className="text-sm font-bold text-gray-900">{`${component.itemDescription ?? ""}` }</p>
                                                  <p className="text-xs font-bold text-gray-400">{`${component.brandName ?? ""}` }</p>
                                                </div>

                                                {/* Dr */}
                                                <div>
                                                  {/* <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Sales (Dr)</p> */}
                                                  <p className="text-xs font-bold text-gray-900">{`${component?.drAccount?.accountName ?? ""}` }</p>
                                                </div>

                                                {/* Cr */}
                                                <div>
                                                  {/* <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Inventory (Cr)</p> */}
                                                  <p className="text-xs font-bold text-gray-900">{`${component?.crAccount?.accountName ?? ""}` }</p>
                                                </div>

                                                {/* Quantities */}
                                                <div>
                                                  {/* <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Quantity</p> */}
                                                  <div className="flex items-center gap-2">
                                                    <div className="text-sm">
                                                        <span className="text-gray-900 font-semibold"> {`${componentQty?.toLocaleString()}  ${component.uomName ?? ""}`}</span>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div>
                                                  {/* <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Quantity</p> */}
                                                  <div className="flex items-center gap-2">
                                                    <div className="text-sm">
                                                        <span className="text-gray-900 font-semibold"> {`${item.totalQuantity?.toLocaleString()}  ${item.uomName ?? ""}`}</span>
                                                    </div>
                                                  </div>
                                                </div>

                                                {/* Pricing */}
                                                <div>
                                                  <p className="text-sm text-gray-900">₱{component?.averageCost?.toLocaleString()}</p>
                                                </div>

                                                {/* Totals */}
                                                <div>
                                                  {/* <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Total Amount</p> */}
                                                  <p className="text-sm font-bold text-green-600">₱{componentTotalAmount?.toLocaleString()}</p>
                                                </div>

                                                {/* Actions */}
                                                {isEditable && (
                                                  <div className="flex justify-end items-center gap-2">
                                                    {actionsDetailComponent?.filter(i => i.name === "Edit")?.map((action, actionIdx) => (
                                                        <button
                                                          key={actionIdx}
                                                          onClick={() => action.function(component)}
                                                          className="p-2 text-gray-400 hover:text-red-600 rounded-lg hover:bg-red-50 transition-all"
                                                        >
                                                          {action.icon || action.label}
                                                        </button>
                                                    ))}
                                                  </div>
                                                )}
                                              </div>
                                            )
                                            })
                                          }
                                        </div>
                                        :
                                        item?.categoryName !== "Other Sale" 
                                        && item?.categoryName !== "Other Sales Income"
                                        && item?.categoryName !== "Other Service Income" ?
                                          <div className="flex flex-col gap-4 mt-2">
                                            <div className="flex items-center gap-2 py-3">
                                              <span className="text-[10px] font-bold uppercase tracking-widest text-indigo-500 bg-indigo-50 px-2 py-0.5 rounded">
                                                Item Components
                                              </span>
                                              <div className="h-px flex-1 bg-gray-100"></div>
                                            </div>
                                            <div className="grid grid-cols-1 md:grid-cols-7 lg:grid-cols-9 gap-2">
                                              {/* Item Info */}
                                              <div className="md:col-span-2">
                                                <p className="text-sm font-bold text-gray-900">{`${item.itemDescription ?? ""}` }</p>
                                                <p className="text-xs font-bold text-gray-400">{`${item.brandName ?? ""}` }</p>
                                              </div>

                                              {/* Dr */}
                                              <div>
                                                <p className="text-xs font-bold text-gray-900">{`${item?.inventoryAccount?.accountName ?? ""}` }</p>
                                              </div>

                                              {/* Cr */}
                                              <div>
                                                <p className="text-xs font-bold text-gray-900">{`${item?.costOfGoodsAccount?.accountName ?? ""}` }</p>
                                              </div>

                                              {/* Quantities */}
                                              <div>
                                                <div className="flex items-center gap-2">
                                                  <div className="text-sm">
                                                    <span className="text-gray-400"> {`${item.receivedQty}  ${item.uomName ?? ""}`}</span>
                                                  </div>
                                                </div>
                                              </div>

                                              <div>
                                                <div className="flex items-center gap-2">
                                                  <div className="text-sm">
                                                    <span className="text-gray-400"> {`${item.totalQuantity}  ${item.uomName ?? ""}`}</span>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Pricing */}
                                              <div>
                                                <p className="text-sm text-gray-900">₱{unitPrice?.toLocaleString()}</p>
                                              </div>

                                              {/* Totals */}
                                              <div>
                                                <p className="text-sm font-bold text-green-600">₱{totalAmount?.toLocaleString()}</p>
                                              </div>

                                              {/* Actions */}
                                              {isEditable && (
                                                <div className="flex justify-end items-center gap-2">
                                                  {actionsDetail?.filter(i => i.name === "Edit")?.map((action, actionIdx) => (
                                                      <button
                                                        key={actionIdx}
                                                        onClick={() => {action.function(item); setIsComponent(true)}}
                                                        className="p-2 text-gray-400 hover:text-red-600 rounded-lg hover:bg-red-50 transition-all"
                                                      >
                                                        {action.icon || action.label}
                                                      </button>
                                                  ))}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          :
                                          <></>
                                      }
                                    </div>
                                  )
                                })}
                              </div>

                              {deliveryReturnDetails.length === 0 && (
                                <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
                                  <p className="text-gray-500">No return details found.</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>

                  {/* Summary when collapsed (Optional) */}
                  {!showDetails && deliveryReturnDetails?.length > 0 && (
                    <motion.p 
                      // initial={{ opacity: 0 }} 
                      // animate={{ opacity: 1 }} 
                      className="text-[11px] text-gray-400 mt-2 italic"
                    >
                      Click to view {deliveryReturnDetails.length} line items...
                    </motion.p>
                  )}
                </div>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex items-center gap-4">
                      <div className="bg-theme-color/10 p-3 rounded-xl">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      <div>
                        <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                          Total Transaction Amount
                        </p>
                        <p className="text-xs text-gray-500">
                          Sum of all returned items above
                        </p>
                      </div>
                    </div>

                    <div className="text-center md:text-right">
                      <div className="flex items-baseline justify-center md:justify-end gap-2">
                        <span className="text-3xl font-black text-gray-800 tracking-tight">
                          {`${getCurrency?.symbol ? getCurrency?.symbol : ""} ${FormatValueToDecimal(amount)}`}
                        </span>
                      </div>
                      {/* Visual indicator of validation */}
                      {amount > 0 ? (
                        <span className="text-[10px] font-bold text-green-500 bg-green-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                          ● Ready to Save
                        </span>
                      ) : (
                        <span className="text-[10px] font-bold text-amber-500 bg-amber-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                          ○ No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Full Width: Notes */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Notes
                  </label>
                  <textarea
                    rows="3"
                    placeholder="Enter any additional details or remarks..."
                    className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    readOnly={!isEditable}
                  />
                </div>
              </div>
              
              <div className="mt-6 space-y-2">
                <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">Attachment</label>
                
                <div className={`relative group transition-all duration-200 rounded-xl border-2 border-dashed 
                  ${uploadedFile ? 'border-theme-color/30 bg-theme-color/5' : 'border-gray-200 hover:border-theme-color/50 bg-gray-50/50 hover:bg-white'}`}>
                  
                  {/* Hidden Input - clickable over the whole area */}
                  {isEditable && (
                    <input
                      type="file"
                      onChange={handleFileChange}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                    />
                  )}

                  <div className="p-4 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      {/* Icon based on state */}
                      <div className={`p-2.5 rounded-lg ${uploadedFile ? 'bg-theme-color text-white' : 'bg-gray-200 text-gray-500'}`}>
                        {uploadedFile ? (
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                        )}
                      </div>

                      <div>
                        <p className={`text-sm font-semibold truncate max-w-[200px] ${uploadedFile ? 'text-gray-800' : 'text-gray-500'}`}>
                          {uploadedFile ? uploadedFile.fileName : "Click to upload file"}
                        </p>
                        <p className="text-[11px] text-gray-400 font-medium">
                          {uploadedFile ? (uploadedFile.contentType || "Document") : "Support any file format"}
                        </p>
                      </div>
                    </div>

                    {/* Action Button */}
                    {uploadedFile && (
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); DownloadFile(uploadedFile); }}
                        className="relative z-20 flex items-center gap-2 px-4 py-2 text-xs font-bold text-theme-color bg-white border border-theme-color/20 rounded-lg shadow-sm hover:bg-theme-color hover:text-white transition-all"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                        DOWNLOAD
                      </button>
                    )}
                  </div>
                </div>
                
                {!uploadedFile && <p className="text-[10px] text-gray-400 italic ml-1">* No file attached yet</p>}
              </div>

            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <DeliveryOrderSelect 
        visible={showReferenceSelectForm} 
        onClose={closeReferenceSelectForm}
        modalName={"Select Available DO"}
        data={reference} setData={setReference}
      />

      <ItemReturnSelect
        visible={showItemSelectForm} 
        onClose={closeItemSelectForm} 
        modalName={"Select Item"}
        data={selectedItem} setData={setSelectedItem} 
        referenceNumber={reference?.doNumber ?? ""} referenceType={"Sales"}
      />

      <AddUpdateDetailModal 
        visible={showUpdateDetailForm} 
        onClose={closeUpdateDetailForm} 
        modalName={"Select Item"}
        // onSave
        data={selectedDetail} setData={setSelectedDetail}
        deliveryReturnDetails={deliveryReturnDetails} setDeliveryReturnDetails={setDeliveryReturnDetails}
        isEditable={true}
        isComponent={isComponent}
      />

      <ConfirmationModal 
        visible={showDeleteDetailForm} 
        onClose={closeDeleteDetailForm} 
        onSave={handleDeleteDetail} 
        modalName={"Delete"} 
        message={`Do you want to remove this [ ${`${selectedDetail?.itemCode} ${selectedDetail?.itemDescription ?? ""}`} ]?.`}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
const ViewModal = ({
  visible,
  onClose,
  modalName,
  data, // selectedData
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [showAccounting, setShowAccounting] = useState(true);
  const printRef = useRef(null);

  if (!visible) return null;

  // Retrieve currency config from localStorage with PHP fallback
  const getCurrency = (() => {
    try {
      return JSON.parse(localStorage.getItem("currency") || '{"code":"PHP","symbol":"₱"}');
    } catch {
      return { code: "PHP", symbol: "₱" };
    }
  })();

  // Helper for currency formatting
  const formatVal = (num) => {
    if (typeof FormatValueToDecimal === "function") {
      return FormatValueToDecimal(num);
    }
    return Number(num || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Resolve values prioritizing direct props, falling back to data (selectedData)
  const currentReturnNumber = data?.returnNumber || "---";
  const currentDoNumber = data?.doNumber || data?.reference?.doNumber || "---";
  const currentReturnDate = data?.returnDate;
  const currentStatus = data?.status || "Pending";
  const currentNotes = data?.notes ?? "";
  const currentUploadedFile = data?.uploadedFile;
  const items = data?.deliveryReturnDetails || [];

  // Compute total amount if not explicitly passed
  const calculatedTotal = items.reduce((sum, item) => sum + Number(item.totalAmount || (item.totalQuantity * item.cost) || 0), 0);

  // Status badge styling
  const getStatusBadge = (st) => {
    const s = (st || "").toLowerCase();
    if (["completed", "approved", "received"].includes(s)) {
      return "bg-emerald-100 text-emerald-700 border border-emerald-200";
    }
    if (["void", "cancelled", "rejected"].includes(s)) {
      return "bg-rose-100 text-rose-700 border border-rose-200";
    }
    if (["in progress", "processing"].includes(s)) {
      return "bg-blue-100 text-blue-700 border border-blue-200";
    }
    return "bg-amber-100 text-amber-700 border border-amber-200";
  };

  const downloadHandleClick = async () => {
    const element = printRef.current;
    if (!element) return;

    setIsDownloading(true);
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        windowWidth: 1200,
        windowHeight: element.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`Delivery_Return_${currentReturnNumber || "Export"}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  // Collect all accounting journal entries from details
  const allAccountEntries = items.flatMap((item, idx) =>
    (item.deliveryReturnDetailAccounts || []).map((acc) => ({
      ...acc,
      itemIndex: idx + 1,
    }))
  );

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.95, opacity: 0, y: 20 }}
          className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
        >
          {/* Header */}
          <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 tracking-tight">
                {modalName || "Delivery Return Preview"}
              </h2>
              <p className="text-sm text-gray-500">Inventory Return & Adjustment Document</p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-8 overflow-y-auto custom-scrollbar">
            <div
              ref={printRef}
              className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-12 min-h-[800px] flex flex-col"
            >
              {/* DOCUMENT HEADER */}
              <div className="flex justify-between items-start border-b-4 border-theme-color pb-8 mb-8">
                <div>
                  <h1 className="text-4xl font-black text-theme-color tracking-tighter mb-2">
                    DELIVERY RETURN
                  </h1>
                  <div className="flex items-center gap-2">
                    <span className={`px-2.5 py-0.5 rounded text-[11px] font-bold uppercase ${getStatusBadge(currentStatus)}`}>
                      {currentStatus}
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    Return Number
                  </p>
                  <p className="text-2xl font-mono font-bold text-theme-color">
                    #{currentReturnNumber}
                  </p>
                  <p className="mt-3 text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    Return Date
                  </p>
                  <p className="text-sm font-bold text-gray-800">
                    {currentReturnDate ? new Date(currentReturnDate).toLocaleDateString() : "N/A"}
                  </p>
                </div>
              </div>

              {/* REFERENCE & CUSTOMER INFO */}
              <div className="grid grid-cols-2 gap-12 mb-10">
                <div className="space-y-2">
                  <h3 className="text-[11px] font-bold text-theme-color uppercase tracking-[0.2em] border-b border-gray-100 pb-2">
                    Customer Details
                  </h3>
                  {data?.customer || data?.customerName1 ? (
                    <div>
                      <p className="font-bold text-gray-900 text-lg">
                        {data?.customer?.name1 || data?.customerName1 || "N/A"}
                      </p>
                      {data?.customer?.name2 && (
                        <p className="text-sm text-gray-500">{data.customer.name2}</p>
                      )}
                      {data?.customer?.street && (
                        <p className="text-xs text-gray-500">{data.customer.street}</p>
                      )}
                      <p className="text-xs text-gray-400 mt-1 font-mono">
                        Customer ID: {data?.customer?.customerId || data?.customerId || "N/A"}
                      </p>
                    </div>
                  ) : (
                    <p className="text-sm italic text-gray-400">No customer information linked.</p>
                  )}
                </div>

                <div className="space-y-3 bg-gray-50 p-6 rounded-xl border border-gray-100">
                  <div className="flex justify-between items-center">
                    <span className="text-[10px] font-bold text-gray-400 uppercase">DO Reference</span>
                    <span className="text-sm font-mono font-bold text-gray-800">
                      #{currentDoNumber}
                    </span>
                  </div>
                  {data?.reference?.doDate && (
                    <div className="flex justify-between items-center">
                      <span className="text-[10px] font-bold text-gray-400 uppercase">Original DO Date</span>
                      <span className="text-sm font-medium text-gray-700">
                        {new Date(data.reference.doDate).toLocaleDateString()}
                      </span>
                    </div>
                  )}
                  <div className="flex justify-between items-center">
                    <span className="text-[10px] font-bold text-gray-400 uppercase">Currency</span>
                    <span className="text-sm font-bold text-gray-700">
                      {getCurrency?.code || "PHP"} ({getCurrency?.symbol || "₱"})
                    </span>
                  </div>
                </div>
              </div>

              {/* ITEMS TABLE */}
              <div className="flex-grow">
                <table className="w-full">
                  <thead>
                    <tr className="bg-theme-color text-white">
                      <th className="py-3 px-4 text-left text-[10px] font-bold uppercase tracking-widest">
                        Item / Description
                      </th>
                      <th className="py-3 px-4 text-center text-[10px] font-bold uppercase tracking-widest">
                        Return Qty
                      </th>
                      <th className="py-3 px-4 text-center text-[10px] font-bold uppercase tracking-widest">
                        Replacement Qty
                      </th>
                      <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">
                        Unit Cost
                      </th>
                      <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">
                        Total Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 border-b border-gray-200">
                    {items?.length > 0 ? (
                      items.map((item, idx) => (
                        <tr key={item.id || idx}>
                          <td className="py-4 px-4">
                            <p className="text-sm font-bold text-gray-800">
                              {item.itemDescription || item.itemName || `Returned Item #${item.id || idx + 1}`}
                            </p>
                            {item.brandName && (
                              <p className="text-xs text-gray-500">{item.brandName}</p>
                            )}
                            {item.notes && (
                              <p className="text-[10px] text-gray-400 mt-1 italic">{item.notes}</p>
                            )}
                          </td>
                          <td className="py-4 px-4 text-center text-sm font-bold text-theme-color">
                            {item.totalQuantity ?? item.quantity ?? 0} {item.uomName || ""}
                          </td>
                          <td className="py-4 px-4 text-center text-sm font-medium text-gray-600">
                            {item.replacementQuantity ?? 0} {item.uomName || ""}
                          </td>
                          <td className="py-4 px-4 text-right text-sm font-medium text-gray-600">
                            {getCurrency?.symbol} {formatVal(item.cost || item.unitPrice)}
                          </td>
                          <td className="py-4 px-4 text-right text-sm font-bold text-gray-900">
                            {getCurrency?.symbol}{" "}
                            {formatVal(item.totalAmount || (item.totalQuantity * (item.cost || 0)))}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="py-10 text-center text-sm text-gray-400 italic">
                          No items found in this return document.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* ACCOUNTING / GL ENTRIES SECTION (COLLAPSIBLE) */}
              {allAccountEntries.length > 0 && (
                <div className="mt-8 pt-6 border-t border-gray-200">
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="text-[11px] font-bold text-theme-color uppercase tracking-widest">
                      Accounting Distributions (GL Entries)
                    </h4>
                    <button
                      type="button"
                      onClick={() => setShowAccounting(!showAccounting)}
                      className="text-xs font-semibold text-theme-color hover:underline"
                    >
                      {showAccounting ? "Hide Entries ▲" : `View Entries (${allAccountEntries.length}) ▼`}
                    </button>
                  </div>

                  {showAccounting && (
                    <div className="overflow-x-auto bg-gray-50 rounded-lg p-3 border border-gray-200">
                      <table className="w-full text-xs">
                        <thead>
                          <tr className="border-b border-gray-200 text-gray-500 uppercase font-semibold text-[9px] text-left">
                            <th className="py-2 px-2">#</th>
                            <th className="py-2 px-2">Debit Account (DR)</th>
                            <th className="py-2 px-2">Credit Account (CR)</th>
                            <th className="py-2 px-2 text-right">Amount</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                          {allAccountEntries.map((acc, accIdx) => (
                            <tr key={acc.id || accIdx}>
                              <td className="py-2 px-2 text-gray-400 font-mono">
                                #{acc.itemIndex}
                              </td>
                              <td className="py-2 px-2 font-medium text-gray-800">
                                <span className="font-mono text-gray-500 mr-1.5">{acc.drAccountNumber}</span>
                                {acc.drAccountName}
                              </td>
                              <td className="py-2 px-2 font-medium text-gray-800">
                                <span className="font-mono text-gray-500 mr-1.5">{acc.crAccountNumber}</span>
                                {acc.crAccountName}
                              </td>
                              <td className="py-2 px-2 text-right font-mono font-bold text-gray-900">
                                {getCurrency?.symbol} {formatVal(acc.amount)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {/* FOOTER SECTION */}
              <div className="mt-8 flex justify-between items-start gap-6 border-t pt-6">
                <div className="w-1/2">
                  <h4 className="text-[10px] font-black text-gray-900 uppercase tracking-widest mb-2">
                    Remarks / Notes
                  </h4>
                  <p className="text-xs text-gray-500 leading-relaxed bg-gray-50 p-4 rounded-lg border border-dashed border-gray-200">
                    {currentNotes || "No remarks or return instructions provided."}
                  </p>

                  {/* Attachment Info */}
                  {currentUploadedFile && (
                    <div className="mt-3 flex items-center gap-2 text-theme-color">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                        />
                      </svg>
                      <span className="text-[10px] font-bold uppercase tracking-tight">
                        Attachment: {currentUploadedFile.name || "Document.pdf"}
                      </span>
                    </div>
                  )}
                </div>

                <div className="w-1/2">
                  <div className="flex justify-between items-center pt-4 border-t-2 border-theme-color">
                    <span className="text-xs font-black text-gray-900 uppercase">
                      Total Return Value
                    </span>
                    <span className="text-2xl font-black text-theme-color">
                      {getCurrency?.symbol} {formatVal(calculatedTotal)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="px-8 py-5 border-t bg-white flex justify-end items-center space-x-4">
            <button
              onClick={onClose}
              className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
            >
              Close
            </button>
            <button
              onClick={downloadHandleClick}
              disabled={isDownloading}
              className={`px-8 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm flex items-center gap-2 ${
                isDownloading ? "opacity-70 cursor-not-allowed" : "hover:opacity-90"
              }`}
            >
              {isDownloading ? (
                <>
                  <svg
                    className="animate-spin h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  Processing...
                </>
              ) : (
                "Download Return Slip"
              )}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
//#endregion








//#region Detail
const AddUpdateDetailModal = ({
  visible, onClose, onSave, modalName,
  data, setData,
  deliveryReturnDetails, setDeliveryReturnDetails,
  isEditable, 
  isComponent,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [failMessage, setFailMessage] = useState("");

  const handleSubmit = async () => {
    if(Number(data.totalQuantity ?? 0) > Number(data.receivedQty ?? 0)){
      setFailMessage(`Returned quantity cannot exceed the received quantity (${data.receivedQty ?? 0}).`)
      return 
    }
    setDeliveryReturnDetails(prev =>
      prev.map(item => {
        return  item.itemCode === data?.itemCode
            ? data
            : item
        }
      )
    );
  

    closeModal();
  };

  const handleSubmitComponent = () => {
    setDeliveryReturnDetails((prev) =>
      prev.map((item) => {
        // Find the parent BOM item
        if (item.id !== data?.detail?.id) {
          return item;
        }

        return {
          ...item,
          itemComponents: item.itemComponents?.map((component) => {
            return (
              // Find the specific BOM component
              component.id === data?.id
                ? {
                    ...component,
                    drAccount: data?.drAccount ?? null,
                    crAccount: data?.crAccount ?? null,
                  }
                : component
            )
          }),
        };
      })
    );

    closeModal();
  };

  const handleQuantityChange = (itemCode, value) => {
    const totalQuantity = Number(value) || 0;

    setDeliveryReturnDetails((prev) =>
      prev.map((item) =>
        item.itemCode === itemCode
          ? {
              ...item,
              totalQuantity,
              totalAmount: totalQuantity * (Number(item.cost) || 0),
              refundQuantity: totalQuantity * (Number(item.cost) || 0),
              itemComponents: item?.itemComponents?.map((comp) => {
                return (
                  {
                    ...comp,
                    detail: {
                      ...item,
                      totalQuantity,
                      totalAmount: totalQuantity * (Number(item.cost) || 0),
                      refundQuantity: totalQuantity * (Number(item.cost) || 0),
                    }
                  }
                )
              })
            }
          : item
      )
    );

    setData((prev) => ({
      ...prev,
      totalQuantity,
      totalAmount: totalQuantity * (Number(data?.cost) || 0),
      refundQuantity: totalQuantity * (Number(data?.cost) || 0),
    }))
  };

  const resetLocalVariables = () => {
    setFailMessage("")
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  const [showDrSelectForm, setShowDrSelectForm] = useState(false);
  const openDrAccountSelectForm = () => {
    setShowDrSelectForm(true);
  }
  const closeDrAccountSelectForm = () => {
    setShowDrSelectForm(false);
  }

  const [showCrSelectForm, setShowCrSelectForm] = useState(false);
  const openCrAccountSelectForm = () => {
    setShowCrSelectForm(true);
  }
  const closeCrAccountSelectForm = () => {
    setShowCrSelectForm(false);
  }



  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Item
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. ITEM0001"
                      className="bg-gray-200 text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={`${data?.itemCode} - ${data?.itemDescription ? `${data?.itemDescription} ${data?.brandName ? `(${data?.brandName})` : ""}` : ""}`}
                      readOnly
                    />
                  </div>

                  { !isComponent ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Returned Quantity
                      </label>
                      <input
                        type="number"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={data?.totalQuantity ?? 0}
                        onChange={(e) => handleQuantityChange(data.itemCode, e.target.value)}
                      />
                      {Number(data.totalQuantity ?? 0) > Number(data.receivedQty ?? 0) && (
                        <p className="mt-1 text-xs text-red-600">
                          {`Returned quantity cannot exceed the received quantity (${data.receivedQty ?? 0}).`}
                        </p>
                      )}
                    </div>
                  :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Returned Quantity
                      </label>
                      <input
                        type="number"
                        className="bg-gray-200 text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={(data.conversionRate ?? 1) * (data?.detail?.totalQuantity ?? 0)}
                        readOnly
                      />
                    </div>
                  }

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Unit Price
                    </label>
                    <input
                      type="number"
                      className="bg-gray-200 text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={data?.unitPrice || data?.averageCost}
                      readOnly
                    />
                  </div>
                  
                  { !isComponent ?
                    <>
                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Tax Amount
                        </label>
                        <input
                          type="number"
                          className="bg-gray-200 text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={
                            ((data?.taxAmount ?? 0) / (data?.receivedQty ?? 0)) 
                            * (data?.totalQuantity ?? 0)
                          }
                          readOnly
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(
                              ((data?.taxAmount ?? 0) / (data?.receivedQty ?? 0)) 
                              * (data?.totalQuantity ?? 0)
                            )}
                          </span>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Discount
                        </label>
                        <input
                          type="number"
                          className="bg-gray-200 text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={
                            ((data?.totalDiscount ?? 0) / (data?.receivedQty ?? 0)) 
                            * (data?.totalQuantity ?? 0)
                          }
                          readOnly
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(
                              ((data?.totalDiscount ?? 0) / (data?.receivedQty ?? 0)) 
                              * (data?.totalQuantity ?? 0)
                            )}
                          </span>
                        </div>
                      </div>
                    </>
                  :
                    <>
                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Tax Amount
                        </label>
                        <input
                          type="number"
                          className="bg-gray-200 text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={0}
                          readOnly
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(0)}
                          </span>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Discount
                        </label>
                        <input
                          type="number"
                          className="bg-gray-200 text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={0}
                          readOnly
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(0)}
                          </span>
                        </div>
                      </div>
                    </>
                  }

                  <div>
                  </div>

                  {isEditable ?
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Dr Account"
                        className="w-full border border-gray-300 text-[12px] rounded-l-lg px-3 py-2 bg-gray-50 font-medium min-w-[150px]"
                        value={data?.drAccount ? `${data?.drAccount?.accountNumber} - ${data?.drAccount?.accountName}` : ""}
                        readOnly
                      />
                      {!data?.drAccount ? (
                        <button onClick={() =>  openDrAccountSelectForm()}
                          className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                        >
                            <ManageSearchIcon className="text-white !text-sm"/>
                        </button> 
                      ) : (
                        <button onClick={() => 
                          setData((prev) => ({
                            ...prev,
                            drAccount: null,
                          }))
                        }
                          className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                        >
                            <RemoveCircleIcon className="text-white !text-sm"/>
                        </button>
                      )}
                    </div> 
                    :
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Dr Account"
                        className="w-full border border-gray-300 text-[12px] rounded-lg px-3 py-2 bg-gray-200 font-medium min-w-[150px]"
                        value={data?.drAccount ? `${data?.drAccount.accountNumber} - ${data?.drAccount.accountName}` : `${data?.accounts[0] ? `${data?.accounts[0]?.drAccount.accountNumber ?? "UNKNOWN"} - ${data?.accounts[0]?.drAccount.accountName ?? "UNKNOWN"}` : ""} `}
                        readOnly
                      />
                    </div> 
                  }

                  {isEditable ?
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Cr Account"
                        className="w-full border border-gray-300 text-[12px] rounded-l-lg px-3 py-2 bg-gray-50 font-medium min-w-[150px]"
                        value={data?.crAccount ? `${data?.crAccount.accountNumber} - ${data?.crAccount.accountName}` : ""}
                        readOnly
                      />
                      {!data?.crAccount ? (
                        <button onClick={() =>  openCrAccountSelectForm()}
                          className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg"
                        >
                            <ManageSearchIcon className="text-white !text-sm"/>
                        </button> 
                      ) : (
                        <button onClick={() => 
                          setData((prev) => ({
                            ...prev,
                            crAccount: null,
                          }))
                        }
                          className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg"
                        >
                            <RemoveCircleIcon className="text-white !text-sm"/>
                        </button>
                      )}
                    </div>
                    :
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Cr Account"
                        className="w-full border border-gray-300 text-[12px] rounded-lg px-3 py-2 bg-gray-200 font-medium min-w-[150px]"
                        value={data?.crAccount ? `${data?.crAccount.accountNumber} - ${data?.crAccount.accountName}` : `${data?.accounts[0] ? `${data?.accounts[0]?.crAccount.accountNumber ?? "UNKNOWN"} - ${data?.accounts[0]?.crAccount.accountName ?? "UNKNOWN"}` : ""} `}
                        readOnly
                      />
                    </div>
                  }

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                      
                      {/* Left Side: Details Breakdown */}
                      <div className="flex gap-4 w-full lg:w-auto">
                        <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                          <AccountBalanceWalletIcon className="text-theme-color" />
                        </div>
                        
                        <div className="flex-1 space-y-3">
                          <div>
                            <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                              Transaction Summary
                            </p>
                            <p className="text-xs text-gray-500">Breakdown of all line items</p>
                          </div>

                          {/* Mini Table for Subtotal, Discount, Tax */}
                          { !isComponent ?
                            <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                              <div className="flex justify-between items-center gap-8">
                                <span className="text-xs font-medium text-gray-500">Subtotal</span>
                                <span className="text-sm font-semibold text-gray-700">
                                  {getCurrency?.symbol} {FormatValueToDecimal(data?.subTotal ?? 0)}
                                </span>
                              </div>
                              
                              <div className="flex justify-between items-center gap-8">
                                <span className="text-xs font-medium text-gray-500">Total Discount</span>
                                <span className="text-sm font-semibold text-red-500">
                                  {getCurrency?.symbol} {FormatValueToDecimal(data?.totalDiscount ?? 0)}
                                </span>
                              </div>

                              <div className="flex justify-between items-center gap-8">
                                <span className="text-xs font-medium text-gray-500">Tax Amount</span>
                                <span className="text-sm font-semibold text-gray-700">
                                  {getCurrency?.symbol} {FormatValueToDecimal(data?.taxAmount ?? 0)}
                                </span>
                              </div>
                            </div>
                          :
                            <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                              <div className="flex justify-between items-center gap-8">
                                <span className="text-xs font-medium text-gray-500">Subtotal</span>
                                <span className="text-sm font-semibold text-gray-700">
                                  {getCurrency?.symbol} {FormatValueToDecimal(
                                    ((data?.conversionRate ?? 1) * (data?.detail?.totalQuantity ?? 0))
                                    * (data?.averageCost ?? 0)
                                  )}
                                </span>
                              </div>
                              
                              <div className="flex justify-between items-center gap-8">
                                <span className="text-xs font-medium text-gray-500">Total Discount</span>
                                <span className="text-sm font-semibold text-red-500">
                                  {getCurrency?.symbol} {FormatValueToDecimal(0)}
                                </span>
                              </div>

                              <div className="flex justify-between items-center gap-8">
                                <span className="text-xs font-medium text-gray-500">Tax Amount</span>
                                <span className="text-sm font-semibold text-gray-700">
                                  {getCurrency?.symbol} {FormatValueToDecimal(0)}
                                </span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>

                      {/* Right Side: Final Total & Status */}
                      { !isComponent ?
                        <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                          <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                            Final Total Amount
                          </p>
                          <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                            <span className="text-4xl font-black text-gray-900 tracking-tight">
                              {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(data?.totalAmount ?? 0)}`}
                            </span>
                          </div>

                          {/* Visual indicator of validation */}
                          {data?.totalAmount > 0 ? (
                            <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                              <span className="mr-1">●</span> Ready to Save
                            </span>
                          ) : (
                            <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                              <span className="mr-1">○</span> No amount detected
                            </span>
                          )}
                        </div>
                        :
                        <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                          <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                            Final Total Amount
                          </p>
                          <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                            <span className="text-4xl font-black text-gray-900 tracking-tight">
                              {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(
                                ((data?.conversionRate ?? 1) * (data?.detail?.totalQuantity ?? 0))
                                * (data?.averageCost ?? 0)
                              )}`}
                            </span>
                          </div>

                          {/* Visual indicator of validation */}
                          {((data?.conversionRate ?? 1) * (data?.detail?.totalQuantity ?? 0)) * (data?.averageCost ?? 0) > 0 ? (
                            <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                              <span className="mr-1">●</span> Ready to Save
                            </span>
                          ) : (
                            <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                              <span className="mr-1">○</span> No amount detected
                            </span>
                          )}
                        </div>
                      }
                    </div>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={!isComponent ? handleSubmit : handleSubmitComponent}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      <ChartOfAccountsSelect 
        visible={showDrSelectForm} 
        onClose={closeDrAccountSelectForm}
        modalName={"Select Account"}
        data={data?.drAccount} 
        setData={(account) =>
          setData((prev) => ({
            ...prev,
            drAccount: account,
          }))
        }
      />

      <ChartOfAccountsSelect 
        visible={showCrSelectForm} 
        onClose={closeCrAccountSelectForm}
        modalName={"Select Account"}
        data={data?.crAccount} 
        setData={(account) =>
          setData((prev) => ({
            ...prev,
            crAccount: account,
          }))
        }
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion













//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  customerFilter, setCustomerFilter,
  statusFilter, setStatusFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_customerFilter, _setCustomerFilter] = useState(customerFilter);
  const [_statusFilter, _setStatusFilter] = useState(statusFilter);

  useEffect(() => {
    if(visible){
      _setCustomerFilter(customerFilter)
      _setStatusFilter(statusFilter)
    }
  }, [visible, customerFilter, statusFilter])

  const handleSubmit = async () => {
    setCustomerFilter(_customerFilter);
    setStatusFilter(_statusFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Customer <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Customer"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_customerFilter ? `${_customerFilter?.customerId} - ${_customerFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_customerFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setCustomerFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Status
                  </label>
                  <InvoiceStatusSelectWithAll data={_statusFilter} setData={_setStatusFilter} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={_customerFilter} setData={_setCustomerFilter}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion